module.exports = __webpack_public_path__ + "img/tixing.ab35f4ef.png";